type Language = {
  days: Array<string>;
  daysShort: Array<string>;
  monthNames: Array<string>;
};

export const temporalLanguages: { [key: string]: Language } = {
  es: {
    days: [
      "Lunes",
      "Martes",
      "Miércoles",
      "Jueves",
      "Viernes",
      "Sábado",
      "Domingo"
    ],
    daysShort: ["Lun", "Mar", "Mié", "Jue", "Vie", "Sáb", "Dom"],
    monthNames: [
      "Enero",
      "Febrero",
      "Marzo",
      "Abril",
      "Mayo",
      "Junio",
      "Julio",
      "Agosto",
      "Septiembre",
      "Octubre",
      "Noviembre",
      "Diciembre"
    ]
  },
  pt: {
    days: [
      "Segunda",
      "Terça",
      "Quarta",
      "Quinta",
      "Sexta",
      "Sábado",
      "Domingo"
    ],
    daysShort: ["Seg", "Ter", "Qua", "Qui", "Sex", "Sab", "Dom"],
    monthNames: [
      "Janeiro",
      "Fevereiro",
      "Março",
      "Abril",
      "Maio",
      "Junho",
      "Julho",
      "Agosto",
      "Setembro",
      "Outubro",
      "Novembro",
      "Dezembro"
    ]
  },
  en: {
    days: [
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
      "Sunday"
    ],
    daysShort: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
    monthNames: [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ]
  }
};

export const defaultOptions = (currencyType = "es") => ({
  sundayFirst: true,
  days: temporalLanguages[currencyType].days,
  daysShort: temporalLanguages[currencyType].daysShort,
  monthNames: temporalLanguages[currencyType].monthNames,
  colors: {
    selected: "#0e54b8",
    inRange: "#e5f7fd",
    selectedText: "white",
    text: "black",
    inRangeBorder: "transparent",
    disabled: "#fff",
    hoveredInRange: "#0e54b8"
  }
});
